import { TOGGLE_EDUCATION_BAR } from "app/action_types/educationBar_action_types";

function getDefaultState(): object {
    return {
        isOpen: false,
    };
}

function toggleEducationBar(state: object = getDefaultState(), action: FixmeType): object {
    switch (action.type) {
        case TOGGLE_EDUCATION_BAR: {
            return Object.assign({}, state, { isOpen: action.isOpen, article: action.article });
        }
        default:
            return state;
    }
}

export default toggleEducationBar;
